import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getUserGrid as getUserGridApi,
  addUserGrid as addUserGridApi,
  updateUserGrid as updateUserGridApi,
  deleteUserGrid as deleteUserGridApi,
} from "../../helpers/fakebackend_helper";
import { toast } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import { createUser, getUserDetail, listUser, doUpdateUser } from "services/user.service";

export const getUserList = createAsyncThunk("users/getUserList", async () => {
  try {
    const response: any = await listUser(0);
    return response.data;
  } catch (error) {
    return error;
  }
});

export const getUser = createAsyncThunk("users/getUserDetail", async (userId: string) => {
  try {
    const response: any = await getUserDetail(userId);
    return response;
  } catch (error) {
    return error;
  }
});

export const addUserList = createAsyncThunk("users/addUserList", async (params: any) => {
  try {
    const response = createUser(params);
    const data = await response;
    toast.success("User Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("User Added Failed", { autoClose: 2000 });
    return error;
  }
});
export const updateUserList = createAsyncThunk("users/updateUserList", async (params: any) => {
  try {
    const response = doUpdateUser(params);
    const data = await response;
    toast.success("User updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("User updated Failed", { autoClose: 2000 });
    return error;
  }
});
export const deleteUserList = createAsyncThunk("users/deleteUserList", async (userId: string) => {
  try {
    const response = doUpdateUser({userId, status: 'inactive'});
    toast.success("User deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("User deleted Failed", { autoClose: 2000 });
    return error;
  }
});

export const activeUserList = createAsyncThunk("users/activeUserList", async (userId: string) => {
  try {
    const response = doUpdateUser({userId, status: 'active'});
    toast.success("User Activation Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("User Activation Failed", { autoClose: 2000 });
    return error;
  }
});

export const getUserGrid = createAsyncThunk("users/getUserGrid", async () => {
  try {
    const response = getUserGridApi();
    return response;
  } catch (error) {
    return error;
  }
});
export const addUserGrid = createAsyncThunk("users/addUserGrid", async (event: any) => {
  try {
    const response = addUserGridApi(event);
    const data = await response;
    toast.success("User Added Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("User Added Failed", { autoClose: 2000 });
    return error;
  }
});
export const updateUserGrid = createAsyncThunk("users/updateUserGrid", async (event: any) => {
  try {
    const response = updateUserGridApi(event);
    const data = await response;
    toast.success("User updated Successfully", { autoClose: 2000 });
    return data;
  } catch (error) {
    toast.error("User updated Failed", { autoClose: 2000 });
    return error;
  }
});
export const deleteUserGrid = createAsyncThunk("users/deleteUserGrid", async (event: any) => {
  try {
    const response = deleteUserGridApi(event);
    toast.success("User deleted Successfully", { autoClose: 2000 });
    return response;
  } catch (error) {
    toast.error("User deleted Failed", { autoClose: 2000 });
    return error;
  }
});
